<template>
    <div class="program-detail-card mr-4 mb-4">
        <p class="cards-title">properties</p>
        
        <!-- Mockup -->
        <template v-if="programTargets">
            <div class="target-value-table pb-3">
                <template v-for="target in programTargets" :key="target.label">
                    <div class="flex items-center">
                        <div class="targets"> {{ target.label }} </div>
                        <div class="values"> {{ target.value }} </div>
                    </div>
                </template>
            </div>
            <a v-if="productBrief != ''" :href="productBrief" target="_blank"
                class=" underline underline-offset-4 text-sm">Product Brief - <span>MUST HAVE</span>
            </a>
        </template>

        <!-- Real section --> 
        <MaterialTargetTable v-if="programVersionTargets" :target-data="programVersionTargets" :is-product-brief="false" />
    </div>
</template>
<script setup lang="ts">

import { defineProps } from 'vue';
import MaterialTargetTable from '@/components/MaterialTargetTable.vue';
import { TargetInterface } from '@/models/programVersionsInterface';

interface TargetMockupInterface {
    value: string,
    label: string
}

defineProps<{
    productBrief?: string,
    programTargets?: TargetMockupInterface[],
    programVersionTargets?: TargetInterface[]; 
}>()


</script>
<style lang="scss" scoped>

.table-title {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.9rem;
    color: $label-blue-strong;
}
.target-info {
    font-weight: 300;
    font-size: 0.8rem;
    color: $font-color-super-light;
    text-transform: capitalize;
}
.value, .value-tbd {
    font-size: 0.9rem;
    color: $font-color-light;
}

// Mockup
.target-value-table {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
}

.targets {
    width: 50%;
    text-align: right;
    padding: 0.5rem;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.8rem;
    color: #6d86bb;
}
.values {
    width: 50%;
    padding: 0.5rem;
    font-size: 0.9rem;
    color: $font-color-light;
    border-left: $border;
}
</style>